import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import createLogger from 'src/utils/logger';
import { Auth } from 'src/api';
import { SaveBtn, Input } from 'src/components/Common';

class ResetPasswordStage2 extends Component {
  constructor() {
    super();
    this.state = {
      password: '',
      passwordErrors: [],
      password_repeat: '',
      resetPwdInProgress: false,
    };
    this.logger = createLogger('ResetPasswordStage2');
  }

  resetPassword = () => {
    if (this.state.password !== this.state.password_repeat) {
      this.setState({ passwordErrors: ['Пароли не воспадают!']})
      return;
    }
    this.setState({ resetPwdInProgress: true });
    Auth.setNewPassword(this.props.resetToken, this.state.password)
      .then(this.onPasswordResetSuccess)
      .catch(this.onPasswordResetError);
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, [e.target.name + 'Errors']: [] });
  }

  onPasswordResetSuccess = () => {
    toast.success('Пароль успешно изменен.');
    this.setState({ resetPwdInProgress: false });
    this.closeModalAndRedirect();
  }

  onPasswordResetError = (error) => {
    this.logger.error('onPasswordResetError()', error);
    this.setState({ resetPwdInProgress: false });
    toast.error('Что-то пошло не так :(')
  }

  closeModalAndRedirect = () => {
    const redirectUrl = '/';
    this.props.closeModal(redirectUrl);
  }

  render() {
    return (
      <div className="modal reset-password">
        <div>
          <h1>Сменить пароль</h1>
          <Input className="modal--input-block modal--input-block__column"
            labelText="Введите новый пароль"
            name="password"
            type="password"
            placeholder="Пароль"
            value={this.state.password}
            onChange={this.handleInputChange}
            errors={this.state.passwordErrors.length ? [''] : []}
          />
          <Input className="modal--input-block modal--input-block__column"
            labelText="Повторите"
            name="password_repeat"
            type="password"
            placeholder="Повторите пароль"
            value={this.state.password_repeat}
            onChange={this.handleInputChange}
            errors={this.state.passwordErrors}
          />
          <SaveBtn saveText="Сменить" cancelText="Отменить"
            onSave={this.resetPassword} onCancel={this.closeModalAndRedirect}
            disabled={this.state.resetPwdInProgress} />
        </div>
      </div>
    );
  }
}

ResetPasswordStage2.propTypes = {
  resetToken: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
}

export default ResetPasswordStage2;



// WEBPACK FOOTER //
// ./src/components/Modal/ResetPassword/ResetPasswordStage2.js